export default __webpack_public_path__ + "static/media/samarqand.e539d1e8.webp";